import * as React from "react";
import { forwardRef } from "react";
const SvgSort = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 181.93 293.79", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M165.77,214.34l-36,36V135.55H107.14V250.32l-36-36L55,230.33l63.47,63.46,63.46-63.46Zm-91-56.1V43.48l36,36,16.16-16L63.46,0,0,63.46l16.16,16,36-36V158.24Z" }));
const ForwardRef = forwardRef(SvgSort);
export default ForwardRef;
